import { Role, RoleType } from "@/trust-admin-app/models/user";
import { accessPermitted } from "../components/helpers";

declare module '@vue/runtime-core' {
  export interface ComponentCustomProperties {
    $accessPermitted: (userRoles: Role[], allowedRoles: Role[] | undefined) => boolean,
    $roleType: () => typeof RoleType
  }
}

export default {
  methods: {
    $accessPermitted(userRoles: Role[], allowedRoles: Role[] = []): boolean {
      return accessPermitted(userRoles, allowedRoles);
    },
    $roleType(): typeof RoleType {
      return RoleType
    }
  },
};
